import _regeneratorRuntime from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import KivaProxy from "@/utils/kivaProxy/src/index";
import { CrmDealTransformer } from "@/transformers/CrmDealTransformer";
import dealsForm from "@/components/deals/dealsForm";
import optionsMixin from "@/mixins/options";
export default {
  mixins: [optionsMixin],
  props: {
    account: Object,
    view: {
      type: String,
      default: "light"
    }
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this.getOptions({
              app: 'crm',
              model: 'deal',
              column: 'stage'
            });
          case 2:
            _this.getData();
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  watch: {
    view: function view(val) {
      this.getData();
      // this.sectionKey ='kk'+Math.random(99,99999);
    }
  },
  data: function data() {
    return {
      accountId: this.account.record_id,
      deals: [],
      loading: false,
      searchKeyword: "",
      popupForm: {
        show: false,
        deal: {}
      }
    };
  },
  components: {
    dealsForm: dealsForm
  },
  methods: {
    setView: function setView(val) {
      this.$emit("setView", val);
    },
    callPhone: function callPhone(val) {
      window.open("tel:" + val);
    },
    editData: function editData(id) {
      this.$store.state.app.templatePopup.data = {
        record_id: id,
        model: "deal",
        openSearchBox: false
      };
      this.$store.state.app.templatePopup.show = true;
    },
    editTask: function editTask(task) {
      this.popupForm.show = true;
      this.popupForm.deal = task;
    },
    getData: function getData() {
      var _this2 = this;
      this.loading = true;
      var filter = {
        account_name: ["=", this.accountId]
      };
      var keyword = "";
      if (this.searchKeyword) {
        keyword = this.searchKeyword;
      }
      var limit = this.view == "light" ? 2 : 100;
      new KivaProxy({
        endpoint: "crm/deal"
      }).setFilters(filter).setKeyword(keyword).setLimit(limit).all().then(function (response) {
        _this2.deals = CrmDealTransformer.fetchCollection(response.records);
        var total = response.total;
        if (_this2.view == "light") {
          _this2.$emit("setTotal", total);
        }
        _this2.loading = false;
      }).catch(function (err) {
        console.log("err", err);
      });
    }
  }
};